
import { mapState, mapGetters } from 'vuex'

export default {
  props: {
    item: { type: Object, required: true },
    field: { type: Object, required: true },
    filters: { type: Array, required: false, default: () => ([]) },
    truncate: { type: Number, default: 50 },
    lineHeight: { type: Number, default: 40 },
    disableHover: { type: Boolean, default: false },
    dense: { type: Boolean, default: false },
    noInteraction: { type: Boolean, default: false }
  },
  data () {
    return {
      hovered: {},
      fullValue: null,
      detailDialog: false
    }
  },
  computed: {
    ...mapState(['env']),
    ...mapGetters('dataset', ['resourceUrl']),
    itemValue () {
      return this.item[this.field.key]
    },
    detailValue () {
      return this.fullValue ?? this.itemValue
    },
    isDigitalDocument () {
      return this.field['x-refersTo'] === 'http://schema.org/DigitalDocument'
    },
    isWebPage () {
      return this.field['x-refersTo'] === 'https://schema.org/WebPage'
    },
    isAccount () {
      return this.field['x-refersTo'] === 'https://github.com/data-fair/lib/account'
    },
    shouldDisplayDetail () {
      if (this.noInteraction) return false
      if (this.isDigitalDocument) return false
      if (this.isWebPage) return false
      return this.field.type === 'string' && !this.field.separator && this.itemValue && this.truncate < this.itemValue.length
    }
  },
  methods: {
    isFilterable (value) {
      if (this.noInteraction) return false
      if (this.field['x-capabilities'] && this.field['x-capabilities'].index === false) return false
      if (this.field['x-refersTo'] === 'https://purl.org/geojson/vocab#geometry') return false
      if (value === undefined || value === null || value === '') return false
      if (typeof value === 'string' && (value.length > 200 || value.startsWith('{'))) return false
      if (this.shouldDisplayDetail) return false
      return true
    },
    hoverValue (value) {
      if (this.disableHover) return
      this._hoverTimeout = setTimeout(() => { this.$set(this.hovered, value, true) }, 60)
    },
    leaveValue (value) {
      if (this.disableHover) return
      if (this._hoverTimeout) {
        clearTimeout(this._hoverTimeout)
        delete this._hoverTimeout
      }
      this.$delete(this.hovered, value)
    }
  }
}
